// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__ddw1L","icon":"Loader_icon__21s1D"};